import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { db } from "@/lib/db-client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { audit } from "@/lib/audit-client";

export const Route = createFileRoute("/_authenticated/admin/settings")({
  component: SettingsAdmin,
});

function SettingsAdmin() {
  const [s, setS] = useState({ max_materials_per_truck: 3, backoffice_email: "", company_name: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    db.from("settings").select("*").eq("id", 1).single().then(({ data }) => {
      if (data) setS({
        max_materials_per_truck: data.max_materials_per_truck,
        backoffice_email: data.backoffice_email,
        company_name: data.company_name,
      });
    });
  }, []);

  const save = async () => {
    setSaving(true);
    const patch = {
      max_materials_per_truck: s.max_materials_per_truck,
      backoffice_email: s.backoffice_email,
      company_name: s.company_name,
      updated_at: new Date().toISOString(),
    };
    const { error } = await db.from("settings").update(patch).eq("id", 1);
    setSaving(false);
    if (error) return toast.error(error.message);
    await audit("settings.update", { entity: "settings", entity_id: "1", metadata: { changes: patch } });
    toast.success("Paramètres enregistrés");
  };

  return (
    <div className="space-y-4 max-w-xl">
      <h1 className="text-2xl font-bold">Paramètres</h1>
      <Card>
        <CardHeader><CardTitle className="text-base">Général</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="company">Nom de l'entreprise (en-tête ticket)</Label>
            <Input id="company" value={s.company_name} onChange={(e) => setS({ ...s, company_name: e.target.value })} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="max">Nombre maximum de matières par camion</Label>
            <Input id="max" type="number" min="1" max="10" value={s.max_materials_per_truck}
              onChange={(e) => setS({ ...s, max_materials_per_truck: parseInt(e.target.value) || 1 })} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="bo">Email back-office (copie reçus & factures)</Label>
            <Input id="bo" type="email" value={s.backoffice_email}
              onChange={(e) => setS({ ...s, backoffice_email: e.target.value })}
              placeholder="compta@entreprise.fr" />
          </div>
          <Button onClick={save} disabled={saving}>{saving ? "…" : "Enregistrer"}</Button>
        </CardContent>
      </Card>
    </div>
  );
}
